import { render, staticRenderFns } from "./DbpyN_Details.vue?vue&type=template&id=7a0de73c"
import script from "./DbpyN_Details.vue?vue&type=script&lang=js"
export * from "./DbpyN_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports